(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chiragan-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chiragan-availability')) {
    customElements.define('chiragan-availability', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.message = this.querySelector('[data-availability-message]');
        this.rows = Array.from(this.querySelector('[data-availability-data]').content.querySelectorAll('[data-variant-id]'));
        this.refresh = () => {
          const variantId = this.form?.querySelector('[name="id"]')?.value;
          const row = this.rows.find(item => item.dataset.variantId === variantId);
          const quantity = Number(this.form?.querySelector('[name="quantity"]')?.value || 1);
          const text = row ? (Number(row.dataset.quantity) > 0 && quantity > Number(row.dataset.quantity)
            ? this.querySelector('[data-availability-partial]').content.textContent
            : row.textContent) : this.querySelector('[data-availability-choose]').content.textContent;
          if (this.message.textContent.trim() !== text.trim()) this.message.textContent = text.trim();
        };
        this.schedule = () => {
          this.timers?.forEach(clearTimeout);
          this.timers = [0, 200, 600].map(delay => setTimeout(this.refresh, delay));
        };
        this.form?.addEventListener('change', this.schedule);
        this.form?.addEventListener('input', this.schedule);
        this.form?.addEventListener('click', this.schedule);
        window.addEventListener('popstate', this.schedule);
        this.schedule();
      }
      disconnectedCallback() {
        this.timers?.forEach(clearTimeout);
        this.form?.removeEventListener('change', this.schedule);
        this.form?.removeEventListener('input', this.schedule);
        this.form?.removeEventListener('click', this.schedule);
        window.removeEventListener('popstate', this.schedule);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
